import { render, staticRenderFns } from "./item7.vue?vue&type=template&id=371f1994&scoped=true"
import script from "./item7.vue?vue&type=script&lang=js"
export * from "./item7.vue?vue&type=script&lang=js"
import style0 from "./item7.vue?vue&type=style&index=0&id=371f1994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f1994",
  null
  
)

export default component.exports